<script setup>

// import Swiper core and required modules
import { Navigation, Pagination, Zoom, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import {onMounted} from "vue";

// Swiper modules
const modules = [Navigation, Pagination, Zoom, A11y];

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/zoom';

var swiperInstance;

const onSwiper = (swiper) => {
	swiperInstance = swiper;
};

onMounted(() => {
	console.log(swiperInstance);
	swiperInstance.zoom.in;
})

const slideTo = (index) => {
	swiperInstance.slideTo(index);
}

defineProps({
	images : Array,
	initial_key : Number
})

defineEmits(['close_image_gallery', 'change_gallery_key'])

</script>

<template>

	<div class="image-gallery-wrapper">

		<i class="lnr icon-cross close-image-gallery" @click="$emit('close_image_gallery')"></i>

		<swiper
			:modules="modules"
			:initial-slide="initial_key"
			:zoom="true"
			:slides-per-view="1"
			:space-between="50"
			:pagination="{ clickable: true }"
			@swiper="onSwiper"
			@slideChange="event => { $emit('change_gallery_key', event.activeIndex) }">

			<swiper-slide v-for="(image) in images">
				<div class="swiper-zoom-container">
					<img :src="'/storage/product_image' + image.name" alt="" class="product_image">
				</div>
			</swiper-slide>

		</swiper>

	</div>

</template>

<script>

export default {
	name: "ImageGallery"
}

</script>